import type { SVGProps } from "react";
export interface CreditCardLockIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function CreditCardLockIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: CreditCardLockIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="m9 11.874.115.006a1.126 1.126 0 0 1 0 2.239L9 14.124H6a1.125 1.125 0 0 1 0-2.25zm13-4.999.115.006a1.125 1.125 0 0 1 0 2.238L22 9.125H2a1.125 1.125 0 0 1 0-2.25z"
      />
      <path
        fill={color}
        d="M17.125 19.875h3.75v-1.75h-3.75zm3.75-10.024V7c0-1.036-.84-1.875-1.875-1.875H5c-1.036 0-1.875.84-1.875 1.875v10c0 1.036.84 1.875 1.875 1.875h7l.115.006a1.126 1.126 0 0 1 0 2.239l-.114.005H5A4.125 4.125 0 0 1 .875 17V7A4.125 4.125 0 0 1 5 2.875h14A4.125 4.125 0 0 1 23.125 7v2.85a1.126 1.126 0 0 1-2.25 0Zm-1.25 4.9a.626.626 0 0 0-1.25 0v1.125h1.25zm2.25 1.313A2.12 2.12 0 0 1 23.125 18v2A2.125 2.125 0 0 1 21 22.125h-4A2.125 2.125 0 0 1 14.874 20v-2c0-.862.515-1.602 1.251-1.936v-1.313a2.875 2.875 0 1 1 5.75 0z"
      />
    </svg>
  );
}
